var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICallGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2673 10.1904C11.2127 10.1297 10.9761 9.86274 10.9215 9.80206C10.697 9.56543 10.6849 9.54723 10.43 9.29847C10.1085 8.98296 9.62306 8.91622 9.25295 9.17105L8.81002 9.47442C8.63407 9.59577 8.39744 9.5897 8.23362 9.45622C7.60867 8.94655 7.0626 8.32161 6.57114 7.47824C6.08575 6.63486 5.81878 5.8461 5.6853 5.05126C5.64889 4.8389 5.76417 4.63261 5.95833 4.5416L6.44372 4.31104C6.77137 4.15328 6.97766 3.80744 6.95946 3.44339C6.94732 3.23103 6.83204 2.86092 6.77137 2.66069C6.69249 2.40586 6.66215 2.31485 6.57114 2.04788C6.42552 1.6353 6.03721 1.36226 5.60035 1.40473C5.23631 1.44114 5.03608 1.46541 4.6963 1.53215C4.45361 1.58069 4.16237 1.64743 3.95608 1.85979C2.86394 2.98833 3.14911 5.81576 4.72057 8.54004C6.28597 11.2522 8.57946 12.9147 10.1024 12.5506C10.3147 12.5021 10.5028 12.3747 10.6485 12.2169C10.8183 12.0288 10.9276 11.9075 11.0853 11.7072C11.2249 11.5313 11.413 11.2764 11.4736 11.052C11.5222 10.8639 11.5161 10.6636 11.4433 10.4816C11.4008 10.3724 11.3341 10.2753 11.2552 10.1904H11.2673Z",
    fill: "#82868C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICallGray);
export default __webpack_public_path__ + "static/media/i_call_gray.a198c6532c8cc8f8be24b477ce624bff.svg";
export { ForwardRef as ReactComponent };